import { Field as ChakraField, Icon, Input, InputGroup, InputProps } from '@chakra-ui/react';
import RequiredIndicator from '@components/ui/RequiredIndicator';
import { hasChanged, isInvalid } from '@utils/validation/validation.utils';
import { Field, FieldInputProps, FormikProps, useFormikContext } from 'formik';
import { FunctionComponent, SVGProps } from 'react';
import { FormattedMessage } from 'react-intl';

import ModifiedTag from './ModifiedField';
type FormInputStringProps = {
  label: string;
  i18nKey?: string;
  required?: boolean;
  icon?: FunctionComponent<SVGProps<SVGSVGElement>>;
} & InputProps;

export function FormInputString<T extends object>({
  label,
  i18nKey,
  required = true,
  icon,
  ...rest
}: Readonly<FormInputStringProps>) {
  const { initialValues, touched, errors, values } = useFormikContext<T>();

  return (
    <ChakraField.Root
      variant="cockpit"
      required={required}
      invalid={required ? isInvalid(label, touched, errors) : false}
    >
      <ChakraField.Label width="100%" height="20px">
        <FormattedMessage id={i18nKey ?? `components.sensorInstallation.form.common.${label}`} />
        <RequiredIndicator />
        {hasChanged(label, initialValues, values) && <ModifiedTag />}
      </ChakraField.Label>
      <Field name={label}>
        {({ field, form }: { field: FieldInputProps<string>; form: FormikProps<T> }) => (
          <InputGroup
            startElement={icon ? <Icon as={icon} color="neutral.500" /> : undefined}
            startElementProps={{ paddingInline: 2 }}
          >
            <Input
              {...field}
              type="text"
              style={{ paddingInlineStart: icon ? '52px' : '16px' }}
              name={label}
              id={label}
              {...rest}
              onChange={form.handleChange}
              onBlur={form.handleBlur}
            />
          </InputGroup>
        )}
      </Field>
    </ChakraField.Root>
  );
}
